import { auditLogReports } from "../../../model/auditlogreports";
import ApproverEnrollments from "./ApproverEnrollments";
import LoginLogout from "./LoginLogout";
import ThresholdChanges from "./ThresholdChanges";
import UserEnrollments from "./UserEnrollments";

const AuditLogReportFactory = (id: string): any => {
    switch(id) {
        case auditLogReports.approverEnrollments.id:
            return ApproverEnrollments;
        case auditLogReports.userEnrollments.id:
            return UserEnrollments;
        case auditLogReports.loginLogout.id:
            return LoginLogout;
        case auditLogReports.thresholdChanges.id:
            return ThresholdChanges;
        default:
            return null;
    }
}

export default AuditLogReportFactory;